import { createServerFn } from "@tanstack/react-start";
import { leadSchema } from "./devis-schemas";

export const submitLead = createServerFn({ method: "POST" })
  .inputValidator((d: unknown) => leadSchema.parse(d))
  .handler(async ({ data }) => {
    // Honeypot: acknowledge silently without storing.
    if (data.hp) return { ok: true as const };

    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { error } = await supabaseAdmin.from("devis_estimatifs").insert({
      type_event: data.type_event,
      date_event: data.date_event || null,
      lieu: data.lieu || null,
      options: [],
      montant_min: 0,
      montant_max: 0,
      nom: data.nom,
      email: data.email || "non-renseigne@dj-val.fr",
      telephone: data.telephone || null,
      message: data.message || null,
      source: data.source,
    });
    if (error) throw new Error(error.message);

    // Notification e-mail au gérant (ne doit jamais faire échouer l'enregistrement).
    try {
      const { sendTransactionalServer } = await import("@/lib/email/send.server");
      await sendTransactionalServer({
        templateName: "nouvelle-demande",
        idempotencyKey: `lead-${data.telephone ?? data.email ?? "x"}-${Date.now()}`,
        templateData: {
          nom: data.nom,
          email: data.email ?? undefined,
          telephone: data.telephone ?? undefined,
          type_event: data.type_event,
          date_event: data.date_event ?? undefined,
          lieu: data.lieu ?? undefined,
          message: data.message ?? undefined,
          source: data.source,
        },
      });
    } catch (e) {
      console.error("Lead notification email failed", e);
    }

    return { ok: true as const };
  });
